var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDashboard = function SvgDashboard(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "transparent",
    stroke: "currentColor",
    d: "M1 12.82h14M14 4.198l-1.22-.502a.318.318 0 0 0-.21.002.263.263 0 0 0-.087.051.2.2 0 0 0-.053.075l-1.34 2.15-1.55-1.25a.267.267 0 0 0-.104-.05.312.312 0 0 0-.123-.006.282.282 0 0 0-.11.041.21.21 0 0 0-.073.079L7 7.68M4.96 1.18H2.07v11.64h2.89V1.18Z"
  })));
};
export default SvgDashboard;